module.exports = __webpack_public_path__ + "static/media/aktuality-clanky-foto.46d8de71.jpg";